import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import GeneratorV2 from './pages/GeneratorV2';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/DashboardV5';
import CentralDestination from './components/CentralDestination';
import Admin from './pages/Admin';
import AdminGenerations from './pages/AdminGenerations';
import ComponentTester from './pages/admin/ComponentTester';
import BackgroundTester from './pages/admin/BackgroundTester';
import ServiceHealthDashboard from './components/admin/ServiceHealthDashboard';
import AdminRoute from './components/AdminRoute';
import ProtectedRoute from './components/ProtectedRoute';
import History from './pages/History';
import AppLayout from './components/layout/AppLayout';
import './App.css';
import './styles/product-ui.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Публичные страницы без общего layout */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Основной layout (Sidebar + Topbar) */}
        <Route element={<AppLayout />}>
          <Route path="/" element={<Home />} />

          {/* Защищённые пользовательские роуты */}
          <Route path="/generator" element={<ProtectedRoute><Navigate to="/generator-v2" replace /></ProtectedRoute>} />
          <Route path="/generator-v2" element={<ProtectedRoute><GeneratorV2 /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><CentralDestination account /></ProtectedRoute>} />
          <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
          <Route path="/referrals" element={<ProtectedRoute><section className="u2-card"><div className="u2-cardInner"><h1 className="u2-title">Реферальная программа пока недоступна</h1><p>Программа будет общей для сервисов портала.</p><a className="u2-btn is-secondary" href="/dashboard">Вернуться к генератору</a></div></section></ProtectedRoute>} />

          {/* Защищённые админские роуты */}
          <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
          <Route path="/admin/generator" element={<AdminRoute><GeneratorV2 key="admin" adminMode /></AdminRoute>} />
          <Route path="/admin-generations" element={<AdminRoute><AdminGenerations /></AdminRoute>} />
          <Route path="/admin/component-tester" element={<AdminRoute><ComponentTester /></AdminRoute>} />
          <Route path="/admin/background-tester" element={<AdminRoute><BackgroundTester /></AdminRoute>} />
          <Route path="/admin/services" element={<AdminRoute><ServiceHealthDashboard /></AdminRoute>} />
          <Route path="/admin/billing" element={<AdminRoute><CentralDestination section="billing" /></AdminRoute>} />
          <Route path="/admin/portal-services" element={<AdminRoute><CentralDestination section="portal-services" /></AdminRoute>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App; 
